export default __webpack_public_path__ + "static/media/galerie6.ba256a43.png";